<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="filter-wrapper">
          <p class="title">Manage Filters:</p>
            <div class="filter-container clearfix">
              <div class="filter-item">
                <select
                  v-model="filters.status"
                  :disabled="isListLoading"
                  class="nice-select"
                  @change="filterList">
                  <option value="">Status: All</option>
                  <option
                    v-for="status in statuses"
                    :key="status.value"
                    :value="status.value"
                    :label="status.label">{{ status.label }}</option>
                </select>
              </div>
              <div class="filter-item search-filter">
                <input
                  v-model="filters.term"
                  :disabled="isListLoading"
                  type="text"
                  placeholder="Job Title"
                  @change="filterList">
                <button
                  :disabled="isListLoading"
                  type="button"
                  @click="filterList"><i class="fa fa-search"></i></button>
              </div>
              <div class="filter-reset-btn">
                <a
                  :class="{ 'disabled-link': isListLoading }"
                  href="javascript:void(0)"
                  title="Refresh"
                  @click="resetFilter">
                  <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                </a>
              </div>
              <div class="float-right">
                <button
                  :disabled="isListLoading"
                  class="btn btn-custom pt-2 pb-2 rounded"
                  @click="handleClickAdd">
                  <span class="fas fa-plus-square">&nbsp;</span> New
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive" style="max-height: 600px !important">
          <base-table
            :data="careers"
            :class="'table align-items-center table-flush projects-table table-light'"
            :thead-classes="'thead-light'"
            :no-data-indication="true"
            :column-length="5"
            :is-loading="isListLoading"
            tbody-classes="list">
            <template slot="columns">
              <th class="text-left">ID</th>
              <th class="text-left">
                <span style="word-break: keep-all">Job Title</span>
              </th>
              <th class="text-left">
                <span style="word-break: keep-all">Date Posted</span>
              </th>
              <th class="text-left">Status</th>
              <th>Actions</th>
            </template>
            <template slot-scope="{row}">
              <td>{{ row.ID }}</td>
              <td>
                <span style="word-break: keep-all">{{ row.post_title }}</span>
                <template v-if="row.meta_job_type_id">
                  <br><span style="word-break: keep-all">{{ row.job_type }}</span>
                  <template v-if="row.meta_location_id">
                    <br><span style="word-break: keep-all">{{ row.location }}</span>
                  </template>
                </template>
              </td>
              <td>
                <span style="word-break: keep-all">{{ row.post_date_gmt }}</span>
              </td>
              <td>
                <select
                  v-model="row.post_status"
                  :disabled="isUpdatingStatus"
                  class="job-post-status"
                  @change="handleUpdateStatus(row)">
                  <option
                    v-for="status in statuses"
                    :key="status.value"
                    :value="status.value"
                    :label="status.label">{{ status.label }}</option>
                </select>
              </td>
              <td class="text-center">
                <template>
                  <button
                    :disabled="isUpdatingStatus"
                    class="btn btn-custom rounded-pill"
                    style="width: 75px !important"
                    @click="handleClickEdit(row)">Edit</button>
                </template>
              </td>
            </template>
          </base-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Careers } from '../../../api/careers'
export default {
  name: 'Careers',
  data() {
    return {
      filters: {
        term: null,
        status: ''
      },
      isListLoading: false,
      isUpdatingStatus: false,
      statuses: [
        {
          label: 'Draft',
          value: 'draft'
        },
        {
          label: 'Publish',
          value: 'publish'
        },
        {
          label: 'Trash',
          value: 'trash'
        }
      ],
      careers: [],
      user: {},
      isManaging: false,
      toManage: {}
    }
  },
  created() {
    this.getCareers()
  },
  methods: {
    getCurrentUser() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user && user.id) this.user = Object.assign({}, user) 
    },
    getCareers() {
      this.isListLoading = true
      Careers(this.filters).then(response => {
        this.careers = response.data.careers
        this.isListLoading = false
      }).catch(error => {
        console.log(error)
        this.isListLoading = false
      })
    },
    filterList() {
      this.getCareers()
    },
    resetFilter() {
      this.filters = {
        term: null,
        status: ''
      }
      this.filterList()
    },
    handleClickEdit(row) {
      this.$router.push({ path: '/careers/' + row.ID })
    },
    handleUpdateStatus(row) {
      this.isUpdatingStatus = true
      Careers({ postID: row.ID, status: row.post_status}, 'put', 'status').then(() => {
        this.getCareers()
        this.isUpdatingStatus = false
      }).catch(error => {
        console.log(error)
        this.isUpdatingStatus = false
      })
    },
    handleClickAdd() {
      this.$router.push({ path: '/careers/new' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .job-post-status {
    padding: 4px;
    border-radius: 4px;
  }
  .projects-table { max-width: 100%; }
  .projects-table th, .projects-table td{ text-align: left; white-space: normal; }
  .projects-table th{ text-align: center; background: #000; color: #FFF; }
  .btn-wrap{ white-space: nowrap; margin-top: 4px; }
  .btn{
    border-radius: 0;
    width: 120px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    font-size: 11px;
    text-decoration: none;
    background: #5bc0de;
    display: inline-block;
  }
  .btn-success{ background: #5cb85c; }
  .projects-table .vtop{ vertical-align: top; }
  .projects-table .vright{ text-align: right; }
  .btn-custom {
    background-color: #6C757D;
    width: 75px !important;
  }
  .disabled-link {
    pointer-events: none !important;
  }
</style>